import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'Users',
  data: function () {
    return {
      user: { login: '', name: '', role: -1, email: '', authenticated: false, account: '', selectedAccount: '' },
      preference: { preferenced: false, linkToWarehouse: false, warehouseId: -1, meterWarehouseId: -1 },
      profile: { login: '', name: '', role: '', email: '', },
    }
  },
  computed: {
    roles: function () {
      return { Employee: 1, Customer: 2 };
    },
    userAuthenticated: function () {
      return this.user && this.user.authenticated;
    },
  },
  methods: {
    resetUserDetails() {
      this.user = { login: '', name: '', role: -1, email: '', authenticated: false };
      this.preference = { preferenced: false, linkToWarehouse: false, warehouseId: -1, meterWarehouseId: -1 };
    },
    getUserDetails(successUrl) {
      if (window.location.href.includes('customerEvaluation'))
        return;
      if (this.$route.name == 'resetPassword' || this.$route.name == 'ebill' || this.$route.name == 'unsubscribe' || this.$route.name == 'confirmLink' || (this.$route.name != null && this.$route.name.includes('/customerEvaluation/')))
        return;

      var login = this.$localStorage.get('_login');
      if (login == null || login == undefined || login == "null") {
        if (this.$route.name != 'login')
          this.$router.push('/login');
      }
      else {
        axios.post('/account/GetProfileDetails', { Username: login })
          .then(response => {
            if (response.data.data.status == 0) {
              var resp = response.data.item;
              this.user = {
                login: login,
                name: resp.name,
                role: resp.role,
                email: resp.email,
                account: resp.account,
                selectedAccount: resp.selectedAccount,
                authenticated: true,
              };
              this.profile.login = login;
              this.profile.name = resp.name;
              this.profile.role = resp.role;
              this.profile.email = resp.email;

              this.preference = {
                preferenced: false,
                linkToWarehouse: resp.linkToWarehouse,
                warehouseId: resp.warehouseId,
                meterWarehouseId: resp.meterWarehouseId,
              };

              this.$localStorage.set('_preference', JSON.stringify(this.preference));
              this.$localStorage.set('_profile', JSON.stringify(this.profile));

              if (successUrl)
                this.$router.push(successUrl);
              else if (this.$route.name == 'home' || this.$route.name == 'login') {
                if (this.user.role == 1) 
                  this.$router.push('/employeeHome');
                else
                  this.$router.push('/userHome');
              }
            }
            else {
              this.resetUserDetails();
              this.$router.push('/login');
            }
          })
          .catch(e => {
            this.resetUserDetails();
            this.$router.push('/login');
          })
      }
    },
    getLoginName() {
      return this.$localStorage.get('_login');
    },
    readSecurities(pageName, controls) {

      var sUrl = '/account/GetSecuritiesEmployee';

      var _profile = this.$localStorage.get('_profile');

      this.profile = JSON.parse(_profile);
      if (!this.profile)
        this.profile = { login: '', name: '', role: '', email: '', };

      if (this.profile.role == this.roles.Customer) {
        sUrl = '/account/GetSecuritiesCustomer';
      }
      axios.post(sUrl, { Value: pageName })
          .then(response => {
            if (response.data.data.status == 0 && response.data.items.length > 0) {
              response.data.items.forEach((item) => {
                var control = controls[item.name];
                if (control) {
                  if (control.employee)
                    if (control.employee.visible != undefined && item.employee.visible != undefined)
                      control.employee.visible = item.employee.visible;
                  if (control.employee)
                    if (control.employee.disabled != undefined && item.employee.disabled != undefined)
                      control.employee.disabled = item.employee.disabled;
                  if (control.customer)
                    if (control.customer.visible != undefined && item.customer.visible != undefined)
                      control.customer.visible = item.customer.visible;
                  if (control.customer)
                    if (control.customer.disabled != undefined && item.customer.disabled != undefined)
                      control.customer.disabled = item.customer.disabled;
                }
              });
            }
          })
          .catch(e => {
            ; // no securities to apply 
          })
    },
    showSecurities(controls) {
      for (var key in controls) {
        if (controls.hasOwnProperty(key)) {
          var control = this.edams_controls[key];
          if (control) {
            if (control.employee)
              if (control.employee.visible != undefined)
                control.employee.visible = true;
            if (control.employee)
              if (control.employee.disabled != undefined)
                control.employee.disabled = false;
            if (control.customer)
              if (control.customer.visible != undefined)
                control.customer.visible = true;
            if (control.customer)
              if (control.customer.disabled != undefined)
                control.customer.disabled = false;
          }
        }
      }
    },
  }
}


